import * as React from "react";
import {connect} from "react-redux";
import {Option} from "ts-option";
import TypeDropdown from "./TypeDropdown";
import Lead from "../../../../model/lead/Lead";
import {Dispatch} from "redux";
import {editLead} from "../../../../store/action/lead/lead";
import Toast from "../../../helper/Toast";
import {RootState} from "../../../../store/reducer/root/RootState";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";

interface ComponentProps {
	/**
	 * Lead.
	 */
	lead: Option<Lead>
}

interface ReduxProps {
	/**
	 * Lead types.
	 */
	leadTypes: DictionaryItem[]
}

interface DispatchProps {
	/**
	 * Edit lead action.
	 * @param {Lead} lead
	 */
	editLead: (lead: Lead) => void;
}

type Props = ComponentProps & ReduxProps & DispatchProps

class LeadTypeDropdown extends React.PureComponent<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onSelect = this.onSelect.bind(this);
	}

	render() {
		const selectedLeadTypeId = this.props.lead.map(l => l.data.leadTypeId).orNull;
		return (
			<TypeDropdown selectedTypeId={selectedLeadTypeId} onSelect={this.onSelect} types={this.props.leadTypes}/>
		);
	}

	onSelect(item: DictionaryItem) {
		this.props.lead.map(l => {
			const updatedLead = l.copy({data: l.data.copy({leadTypeId: item.id})});
			this.props.editLead(updatedLead);
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editLead: (lead: Lead) => dispatch(
			editLead(
				lead,
				() => Toast.success("Lead type updated", "Lead details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Lead details update"))
		)
	}
}

function mapStateToProps(state: RootState) {
	return {
		leadTypes: state.leadType.leadTypes.getOrElse([])
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadTypeDropdown)